import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component that redirects to the login page if the user is not authenticated
 * @param {object} props Component props
 * @param {object} props.user The user object if authenticated, null otherwise
 * @param {React.ReactNode} props.children Child components to render if authenticated
 * @param {string} props.redirectPath Path to redirect to if not authenticated (defaults to '/auth')
 * @returns {React.ReactNode} The children if authenticated, or a redirect if not
 */
const ProtectedRoute = ({ user, children, redirectPath = '/login' }) => {
  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute; 